module.exports = __webpack_public_path__ + "img/fram2.1cf4543b.png";